import { ButtonLink } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import {
  faCookie,
  faPlus,
  faSquareDollar,
  faTag,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PaidProgramGuide } from './paidProgramsGuide';
import { EmptyStateGuideInfo } from './emptyStateGuideInfo';
import OtpEmptyStateImg from './otp-empty-state.png';
import { EmptyStateCard } from './EmptyStateCard';

export type OtpEmptyStateProps = {
  isGuideOpen: boolean;
  closeGuide: () => void;
  openGuide: () => void;
  to: string;
  name: string;
  guideLink: string;
};

const options = [
  {
    icon: faTag,
    title: 'Fixed price for a single product',
    details: 'Create your first program, price tag it and start selling.',
  },
  {
    icon: faSquareDollar,
    title: 'Paywalled access',
    details: 'Anyone who purchased gets a lifetime access.',
  },
  {
    icon: faCookie,
    title: 'Lead generation',
    details:
      'Good for testing your audience and their interest in your programs.',
  },
];

export const OtpEmptyState = ({
  to,
  isGuideOpen,
  closeGuide,
  openGuide,
  name,
  guideLink,
}: OtpEmptyStateProps) => (
  <div className="w-full h-full flex flex-col gap-8 items-center">
    <EmptyStateGuideInfo
      name={name}
      type="Paid programs"
      guideLink={guideLink}
    />
    <div className="p-6 w-full h-max bg-white rounded-[10px] flex justify-between flex-col md:flex-row gap-12 md:gap-2">
      <div className="w-full h-max flex flex-col gap-6">
        <Typography variant="headline" size="small">
          Create your first One-Time Purchase
        </Typography>
        <EmptyStateCard options={options} />
        <ButtonLink color="neutral" className="w-[180px]" to={to}>
          <div className="flex items-center gap-1">
            <FontAwesomeIcon icon={faPlus} />
            <Typography>Create</Typography>
          </div>
        </ButtonLink>
        {/* <div className="flex flex-col gap-2">
          <Typography variant="body" size="medium">
            Learn how to create a program that sells.
          </Typography>
          <Typography
            variant="body"
            size="medium"
            onClick={openGuide}
            color="P-80"
            className="cursor-pointer"
          >
            Guide
          </Typography>
        </div> */}
        <PaidProgramGuide isOpen={isGuideOpen} close={closeGuide} />
      </div>
      <img
        src={OtpEmptyStateImg}
        className="w-full md:w-[50%] max-h-[340px] object-contain self-center"
      />
    </div>
  </div>
);
